	import Vue from 'vue'
	import './plugins/vuetify'
	import App from './App.vue'
	import router from './router'
	import store from './store'
	import './registerServiceWorker'

	Vue.config.productionTip = false


	import VueResource from 'vue-resource'
	Vue.use(VueResource)
	Vue.http.options.emulateJSON = true
	Vue.http.options.credentials = true;
	Vue.http.options.xhr = {
		withCredentials: true
	};
	Vue.http.options.crossOrigin = true

	Vue.http.headers.common['Content-Type'] = 'application/json'
	Vue.http.headers.common['Access-Control-Allow-Origin'] = '*'
	Vue.http.headers.common['Accept'] = 'application/json, text/plain, */*'
	Vue.http.headers.common['Access-Control-Allow-Headers'] = 'Origin, Accept, Content-Type, Authorization, Access-Control-Allow-Origin'

	const moment = require('moment')
	require('moment/locale/tr')
	Vue.use(require('vue-moment'), {
		moment
	})


	// import imagelist from "vue-amiral-imagelist" 
	import imagelist from 'vue-amiral-imagelist/src/plugin.js'
	Vue.use(imagelist, {
		upload_target_url: process.env.VUE_APP_API_URL + "/fileupload/index",
		upload_group_method: "query",
		upload_accept_filetype: "image/*,video/*"
	})


	import VueAwesomeSwiper from 'vue-awesome-swiper'
	import 'swiper/dist/css/swiper.css'
	Vue.use(VueAwesomeSwiper, /* { default global options } */ )


	import VueClipboard from 'vue-clipboard2'
	VueClipboard.config.autoSetContainer = true // add this line
	Vue.use(VueClipboard)
 
	import CKEditor from '@ckeditor/ckeditor5-vue'; 
	Vue.use( CKEditor );
 
	new Vue({
		router,
		store, 
		render: h => h(App)
	}).$mount('#app') 